import { render } from "./PlatMerchantRelationErp.vue?vue&type=template&id=7a520456&scoped=true"
import script from "./PlatMerchantRelationErp.vue?vue&type=script&lang=js"
export * from "./PlatMerchantRelationErp.vue?vue&type=script&lang=js"

import "./PlatMerchantRelationErp.vue?vue&type=style&index=0&id=7a520456&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a520456"]])

export default __exports__